import { ComponentProps, forwardRef, ReactNode } from 'react'
import { cn } from '../utils'
import { Badge as InternalBadge } from '@bpinternal/ui-kit-next'
import { Color } from '~/types'

type Props = {
  children: ReactNode
  className?: string
  color?: Color
} & ComponentProps<typeof InternalBadge>

const variantMap = (color: Color, variant: ComponentProps<typeof InternalBadge>['variant']) => {
  return {
    default: `bg-${color}-8`,
    secondary: `bg-${color}-3 text-${color}-10`,
    destructive: `bg-${color}-2 text-${color}-10`,
    outline: `bg-${color}-2 text-${color}-10 border-${color}-7`,
  }[variant ?? 'default']
}

const getColorVariant = (color: Color, variant: ComponentProps<typeof InternalBadge>['variant']): string => {
  return variantMap(color, variant)
}

export const Badge = forwardRef<HTMLDivElement, Props>(({ children, className, color, variant, ...props }, ref) => {
  return (
    <InternalBadge
      ref={ref}
      className={cn(
        color && getColorVariant(color, variant),
        'rounded-sm px-1.5 shadow-none hover:shadow-none',
        className
      )}
      variant={variant}
      {...props}
    >
      {children}
    </InternalBadge>
  )
})

Badge.displayName = 'Badge'
